import React, { useState, useCallback, useEffect, useRef } from 'react';
import * as THREE from 'three';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';

const buttonStyle = {
  position: 'absolute',
  left: '50%',
  bottom: '20px',
  transform: 'translateX(-50%)',
  padding: '8px 24px',
  minWidth: '160px',
  backgroundColor: 'rgba(0, 255, 0, 0.15)',
  border: '1px solid rgba(0, 255, 0, 0.5)',
  textAlign: 'center',
  color: '#00ff00',
  cursor: 'pointer',
  fontFamily: 'monospace',
  fontSize: '12px',
  letterSpacing: '1px',
  transition: 'all 0.3s ease',
  pointerEvents: 'auto',
  zIndex: 2000,
  userSelect: 'none',
  textShadow: '0 0 5px rgba(0, 255, 0, 0.5)',
  backdropFilter: 'blur(2px)',
  borderRadius: '4px',
  textTransform: 'uppercase',
};

const hoverStyle = {
  backgroundColor: 'rgba(0, 255, 0, 0.25)',
  border: '1px solid rgba(0, 255, 0, 0.8)',
  boxShadow: '0 0 15px rgba(0, 255, 0, 0.3)',
  textShadow: '0 0 8px rgba(0, 255, 0, 0.8)',
};

function ResetCameraButton({ state }) {
  const buttonRef = useRef(null);
  const labelRef = useRef(null);

  useEffect(() => {
    
  }, [state]);

  const [isHovered, setIsHovered] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const resetCamera = useCallback(() => {
    

    if (!state?.camera || !state?.controls?.current || isAnimating) {

      return;
    }
    
    const { camera, controls: { current: controls } } = state;

    setIsAnimating(true);

    const targetPosition = new THREE.Vector3(50, 50, 50); // Match final position from IntroAnimation
    const currentPosition = camera.position.clone();
    
    // Disable controls during animation
    controls.enabled = false;

    // Animation variables
    const duration = 2000; // Match intro animation duration (2 seconds)
    const startTime = Date.now();

    // Animation function
    function animate() {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Match intro animation's smooth easing
      const easeProgress = 1 - Math.pow(1 - progress, 3); // Cubic ease-out for smoother end

      // Interpolate position
      camera.position.lerpVectors(currentPosition, targetPosition, easeProgress);
      
      // Look at center
      camera.lookAt(0, 0, 0);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Re-enable controls after animation
        controls.enabled = true;
        controls.target.set(0, 0, 0);
        controls.update();
        setIsAnimating(false);
      }
    }

    animate();
  }, [state, isAnimating]);

  return (
    <div
      ref={buttonRef}
      style={{
        position: 'absolute',
        zIndex: 2000,
        left: '50%',
        bottom: '20px',
        transform: 'translateX(-50%)',
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <button
        onClick={resetCamera}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          ...buttonStyle,
          ...(isHovered ? hoverStyle : {}),
          opacity: isAnimating ? 0.5 : 1,
          cursor: isAnimating ? 'default' : 'pointer',
          pointerEvents: 'auto'
        }}
        disabled={isAnimating}
      >
        {isAnimating ? 'Resetting...' : 'Reset CamerA'}
      </button>
    </div>
  );
}

export default ResetCameraButton;